import { render } from "./car_type.vue?vue&type=template&id=b23eba32&scoped=true&ts=true"
import script from "./car_type.vue?vue&type=script&lang=ts"
export * from "./car_type.vue?vue&type=script&lang=ts"

import "./car_type.vue?vue&type=style&index=0&id=b23eba32&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b23eba32"]])

export default __exports__